import { SOFTWARE_VERSION_CONNECT_REMOTE_MAJOR } from 'components/MyMachineDetails/util/constant';

export const isRemoteControllable = (version) => {
  if (!version) {
    return false;
  }

  const regex = /^(.*?)?(\d+)\.(\d+)\.(\d+)(.*)$/;
  const matches = version.match(regex);
  let majorVersion = SOFTWARE_VERSION_CONNECT_REMOTE_MAJOR;

  if (matches) {
    // eslint-disable-next-line no-unused-vars
    const [, prefix, major, minor, patch, suffix] = matches;
    majorVersion = Number(major);
  }
  return Number.isNaN(majorVersion)
    ? true
    : majorVersion >= SOFTWARE_VERSION_CONNECT_REMOTE_MAJOR;
};
